import {TCustomIconLinkProps} from "@/app/[locale]/common/components/CustomIconLink/types";
import s from './CustomIconLink.module.scss';
import {Link} from '@/i18n/routing';

export const CustomIconLink = (
    {
        leftIcon,
        rightIcon,
        leftMargin,
        href,
        className,
        children,
        onClick,
        onMouseOver,
        onMouseOut,
    }: TCustomIconLinkProps) => {
    return (
        <Link href={href} className={`${s.link} ${className}`} aria-label="Customise link" onClick={onClick}
                onMouseOver={onMouseOver} onMouseOut={onMouseOut}>
            {leftIcon && <span className={`${s.iconContainer} ${s.leftIcon}`}>{leftIcon}</span>}
            {children && <span className={`${s.text} ${leftMargin && s[leftMargin]}`}>{children}</span>}
            {rightIcon && <span className={s.iconContainer}> {rightIcon} </span>}
        </Link>
    );
};